define("settings/components/profiles/auto-publish", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--text--md u--m__b__lg">
    {{t "account.social_accounts.auto_publish.description"}}
  </p>
  <div class="o--formWrapper">
    <label class="o--checkbox--switch">
      <Input @checked={{@socialProfile.autoPublishFollowUp}} @type="checkbox" data-test-id="auto-publish-follow-up" />
      <div class="o--checkbox__track">
        <div class="o--checkbox__knob"></div>
      </div>
      <span class="o--checkbox__label">
        {{t "account.social_accounts.auto_publish.follow_up"}}
      </span>
    </label>
  </div>
  <div class="o--formWrapper">
    <label class="o--checkbox--switch">
      <Input @checked={{@socialProfile.defaultAutoPublish}} @type="checkbox" data-test-id="default-auto-publish" />
      <div class="o--checkbox__track">
        <div class="o--checkbox__knob"></div>
      </div>
      <span class="o--checkbox__label">
        {{t "account.social_accounts.auto_publish.default_auto_publish"}}
      </span>
    </label>
  </div>
  <div class="o--btnBar u--float--right">
    <Shared::Ui::Button
      @promise={{@saveSocialProfile}}
      @text={{t "shared_words.save"}}
      @variant="primary"
      data-test-id="save-button"
    />
  </div>
  */
  {
    "id": "koB+K4Bk",
    "block": "[[[10,2],[14,0,\"u--text--md u--m__b__lg\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"account.social_accounts.auto_publish.description\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"o--checkbox--switch\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,\"data-test-id\",\"auto-publish-follow-up\"]],[[\"@checked\",\"@type\"],[[30,1,[\"autoPublishFollowUp\"]],\"checkbox\"]],null],[1,\"\\n    \"],[10,0],[14,0,\"o--checkbox__track\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--checkbox__knob\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--checkbox__label\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.social_accounts.auto_publish.follow_up\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"o--checkbox--switch\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,\"data-test-id\",\"default-auto-publish\"]],[[\"@checked\",\"@type\"],[[30,1,[\"defaultAutoPublish\"]],\"checkbox\"]],null],[1,\"\\n    \"],[10,0],[14,0,\"o--checkbox__track\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--checkbox__knob\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--checkbox__label\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.social_accounts.auto_publish.default_auto_publish\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n  \"],[8,[39,2],[[24,\"data-test-id\",\"save-button\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,2],[28,[37,0],[\"shared_words.save\"],null],\"primary\"]],null],[1,\"\\n\"],[13]],[\"@socialProfile\",\"@saveSocialProfile\"],false,[\"t\",\"input\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/profiles/auto-publish.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});